/* eslint-disable @stylistic/semi */

import $ from '../util/jquery.js'
import Message from '../util/message.js'
import ScrollProximityHandler from '../util/scroll-proximity-handler.js';
import { isBot } from '../util/is-bot.js';

class Related {
  /**
   * Processing to get related item using new API, Get response and Render
   */
  static setup() {
    const $related = $('#js-related');
    if (!$related.length || isBot) return;

    // GET top offset of #also-found(related item section) and executing ajax call accordingly
    const alsoFound = $('#also-found')

    this.scrollProximityHandler = new ScrollProximityHandler(
      'related_items',
      alsoFound,

      () => {
        if (!$related.text()) {
          alsoFound.find('.tilebars').show()
          $related.html(Message.LoadingMessage({ message: 'Fetching items' }))
          return Related.doWhenScrolledToRelatedSection();
        }
      },
    );

    this.scrollProximityHandler.startListener();
  }


  /**
   * Get API response from Related.getRelatedItems() after #js-related scrolled and
   * render response
   *
   * @return {Promise}
   */
  static doWhenScrolledToRelatedSection() {
    const identifier = $('#also-found').data('identifier')
    const $related = $('#js-related')

    return Related.getRelatedItems(identifier)
      .then((response) => {
        // write response HTML markup to related items section
        $related.html(response)
      })
      .catch((error) => {
        $('#playplayset').hide() // Hide playset

        // Show the related items section, so we can display error
        $related.html(Message.ErrorMessage({ errorMessage: error.message })).show()
      })
  }


  /**
   * API call to get related item and return response using Promise
   *
   * @param  {String} identifier item identifier
   * @param  {Boolean} json truthy to return JSON instead of markup HTM
   * @return {Promise<Array|String>}
   */
  static getRelatedItems(identifier, json) {
    return new Promise((resolve, reject) => {
      const relatedUrl = `/details/${encodeURIComponent(identifier)}?RelatedItemsGet=${(json ? 'json' : 1)}`
      const errorMessage = 'Related items temporarily unavailable. Please try back later.';

      $.get(relatedUrl, (response) => {
        if (response === '') reject(new Error('No similar items found.'))
        if (response === 'service_disabled') reject(new Error(errorMessage))
        resolve(response) // Return related items hashData using Promise
      }).fail(() => {
        reject(new Error(errorMessage)) // Return error message to Promise when any error found
      })
    })
  }
}

$(() => Related.setup())

export { Related as default }
